const _ = require('lodash'),
path = require('path')

/**
 * This code reads the files in config and create a hash to each json file and its content values
 * @example
 * Util.createConfigurationHash();
 * //output
 *   {
        development: {amazon: {s3BucketURL: 'https://s3-us-west-2.amazonaws.com/development/'} },
        local: {amazon: {s3BucketURL: 'https://s3-us-west-2.amazonaws.com/local/'} },
        production: {amazon: {s3BucketURL: 'https://s3-us-west-2.amazonaws.com/production/'} },
        test: {amazon: {s3BucketURL: 'https://s3-us-west-2.amazonaws.com/test/'} }
      }
 */
function createConfigurationHash(){
   const configurations = {
        development: {},
        local: {},
        production: {},
        test: {}
     }

     for(let key in configurations){
            _.forEach(["amazon.json", 'shopify.json'], fileName => {
              let hashName = fileName.replace(".json","")
              configurations[key][hashName] = require(`./config/${key}/${fileName}`)
            });
     }
    return configurations;
}

const configurations = createConfigurationHash()

var tagValueToTextMap = [
    {value: 'yes', text: 'Yes'},
    {value: 'no', text: 'No'},
    {value: 'no_3m+', text: 'No, 3m+'},
    {value: 'no_6m+', text: 'No, 6m+'},
    {value: 'yes_bassinet_sold_separately', text: 'Yes, with bassinet (sold separately)'},
    {value: 'yes_adapter_carseat', text: 'Yes, with compatible adapter and car seat'},
    {value: 'yes_adapter_carseat_or_bassinet', text: 'Yes, with compatible adapter and car seat or bassinet'},
    {value: 'yes_carseat', text: 'Yes, with compatible car seat'},

]


var  rolesToResourcesAccessMap = {

    'dashboard': {
        AllowedRoles: ['AMT Team', 'Wingmom', 'Ops Manager', 'Product Manager', 'Administrator'],
      doNotDisplayInSelect:true,
        pathToMatch: '^\/admin$'
    },
    'AMT_page': {
        AllowedRoles: [  'Administrator','AMT Team'],
        pathToMatch: '^\/admin\/reports.*'
    },

    'categories_edit': {
        AllowedRoles: ['Product Manager', 'Administrator'],
        pathToMatch: '^\/admin\/categories.*'
    },

     'contractors_edit': {AllowedRoles: ['Administrator'],pathToMatch: '^\/admin\/contractors.*'},
    'contractors_reports_view': {
        AllowedRoles: ['Wingmom', 'Ops Manager',  'Product Manager','Administrator'],
        pathToMatch: '^\/admin\/reports.*'
    },
    'KPI_reports_view': {
        AllowedRoles: [  'Product Manager','Ops Manager', 'Administrator'],
        pathToMatch: '^\/admin\/reports.*'
    },
    'contractors_reports_full': {
        AllowedRoles: ['Ops Manager', 'Administrator'],
        pathToMatch: '^\/admin\/reports.*'
    },
    'emails_edit': {
        AllowedRoles: ['Product Manager', 'Administrator'],

        pathToMatch: '^\/admin\/emails.*'
    },

    'fulfillment_edit': {
        AllowedRoles: ['Ops Manager', 'Product Manager', 'Administrator'],
        pathToMatch: '^\/admin\/fulfillment.*'
    },


    'GBG_products_edit': {
        AllowedRoles: ['Product Manager', 'Administrator'],

        pathToMatch: '^\/admin\/gbg-products.*'
    },

    'inventory_recon_view': {
        AllowedRoles: [ 'Financial Analyst',  'Administrator'],

        pathToMatch: '^\/admin\/inventory-recon.*'
    },
    'inventory_recon_full': {
        AllowedRoles: [   'Administrator'],

        pathToMatch: '^\/admin\/inventory-recon.*'
    },

    'inventory_projects_edit': {
        AllowedRoles: [  'Administrator'],

        pathToMatch: '^\/admin\/inventory-projects.*'
    },
    'processing_3PL': {
        AllowedRoles: [ 'Administrator', 'Wingmom'],
        resourceLabel:'Processing-3PL',
        pathToMatch: '^\/admin\/processing-3PL$'
    },
    'processing_seller': {
        AllowedRoles: [ 'Administrator','Wingmom'],
        resourceLabel:'Processing-Seller',
        pathToMatch: '^\/admin\/processing-seller$'
    },
    'processing_3PL_manager': {
        AllowedRoles: ['Administrator'],
        resourceLabel:'Processing-3PL Manager',
        pathToMatch: ['^\/admin\/processing-3PL-manager.*']
    },
    'metro_areas_edit': {
        AllowedRoles: ['Product Manager', 'Administrator'],
        pathToMatch: [ '^\/admin\/metro-areas.*', '^\/admin\/metro-area\/.*\/edit','^\/admin\/metro-area\/add'],
     },
     'inboundRebound': {
        AllowedRoles: [ 'Administrator', 'Wingmom'],
        resourceLabel:'Inbound Rebound',
        pathToMatch: '^\/admin\/inboundRebound$'
     },

    'orders_view': {
        AllowedRoles: ['Ops Manager', 'Product Manager', 'Administrator'],
        pathToMatch: '^\/admin\/orders.*'
    },
    'orders_edit': {
        AllowedRoles: ['Ops Manager', 'Product Manager', 'Administrator'],

        pathToMatch: '^\/admin\/orders.*'
    },
    'orders_full': {
        AllowedRoles: [  'Product Manager', 'Administrator'],

        pathToMatch: '^\/admin\/orders.*'
    },
    'pallets_edit': {
        AllowedRoles: ['Ops Manager', 'Product Manager', 'Administrator'],
        pathToMatch: '^\/admin\/pallets.*'
    },

    'partner_dashboard': {
        doNotDisplayInSelect:true,
        AllowedRoles: ['Partner', 'Administrator'],pathToMatch: '^\/partner$'},
    'partner_products': {
        AllowedRoles: ['Partner', 'Administrator'],
        doNotDisplayInSelect:true,
        pathToMatch: '^\/partner\/products.*'
    },
    'partner_transactions': {
        AllowedRoles: ['Partner', 'Administrator'],
        doNotDisplayInSelect:true,
        pathToMatch: '^\/partner\/transactions.*'
    },
    'payout_registry_view': {
        AllowedRoles: [  'Financial Analyst', 'Administrator'],
       pathToMatch: '^\/admin\/payout-registry.*'
    },
    'payout_registry_edit': {AllowedRoles: ['Administrator'],pathToMatch: '^\/admin\/payout-registry.*'},
    'payout_registry_full': {AllowedRoles: ['Administrator'],pathToMatch: '^\/admin\/payout-registry.*'},

    'products_view': {
        AllowedRoles: ['Ops Manager', 'Product Manager', 'Financial Analyst', 'Administrator'],
       pathToMatch: '^\/admin\/products.*'
    },
    'products_edit': {
        AllowedRoles: [ 'Ops Manager', 'Product Manager', 'Administrator'],
        AllowedRolesApp: [ 'Wingmom'],
        pathToMatch:['^\/admin\/products.*','^\/admin\/product\/.*\/edit']
    },
    'products_full': {
        AllowedRoles: [ 'Ops Manager', 'Product Manager', 'Administrator'],
        pathToMatch:['^\/admin\/products.*','^\/admin\/product\/.*\/edit']
    },

    'promo_codes_edit': {
        AllowedRoles: ['Product Manager', 'Administrator'],
        pathToMatch: '^\/admin\/promo-codes.*'
    },

    'quality_checks_edit': {
        AllowedRoles: [ 'Product Manager', 'Administrator'],

        pathToMatch: '^\/admin\/quality-checks.*'
    },



    'sellers_view': {
        AllowedRoles: ['Ops Manager', 'Product Manager',   'Administrator'],
       pathToMatch: '^\/admin\/sellers.*'
    },
    'sellers_edit': {AllowedRoles: [ 'Product Manager', 'Administrator'],
        pathToMatch: ['^\/admin\/sellers.*','^\/admin\/seller\/.*\/edit','^\/admin\/seller\/.*\/add']},
    'sellers_full': {AllowedRoles: [ 'Product Manager', 'Administrator'],
        pathToMatch: ['^\/admin\/sellers.*','^\/admin\/seller\/.*\/edit','^\/admin\/seller\/.*\/add']},

     'services_edit': {
        AllowedRoles: ['Ops Manager', 'Product Manager', 'Administrator'],
        pathToMatch: '^\/admin\/services.*'
    },
    'services_full': {
        AllowedRoles: [  'Product Manager', 'Administrator'],
        pathToMatch: '^\/admin\/services.*'
    },
    'services_areas_edit': {
        AllowedRoles: ['Ops Manager', 'Product Manager', 'Administrator'],
        pathToMatch: '^\/admin\/service-areas.*'
    },

    'settings_edit': {
        AllowedRoles: ['Product Manager', 'Administrator'],

        pathToMatch: '^\/admin\/settings.*'
    },


    'subscriptions_edit': {
        AllowedRoles: ['Product Manager', 'Administrator'],
        resource: 'subscriptions_edit',
        pathToMatch: '^\/admin\/subscriptions.*'
    },
    'subscriptions_full': {
        AllowedRoles: ['Product Manager', 'Administrator'],
        resource: 'subscriptions_edit',
        pathToMatch: '^\/admin\/subscriptions.*'
    },
    'time_tracking_view': {
        AllowedRoles: ['Financial Analyst', 'Administrator',
            'Wingmom'
        ],

        pathToMatch: '^\/admin\/time-tracking.*'
    },
    'time_tracking_edit': {AllowedRoles: ['Administrator'],pathToMatch:[ '^\/admin\/time-tracking.*', '^\/admin\/time-tracking-registry.*'] },
    'time_tracking_full': {AllowedRoles: ['Administrator'],pathToMatch:[ '^\/admin\/time-tracking.*', '^\/admin\/time-tracking-registry.*'] },

    'users_view': {
        AllowedRoles: ['Ops Manager', 'Product Manager', 'Administrator'],
        pathToMatch: '^\/admin\/users.*'
    },
    'users_edit': {AllowedRoles: ['Administrator'],   pathToMatch: ['^\/admin\/users.*','^\/admin\/user\/.*\/edit','^\/admin\/user\/add']},
    'users_full': {AllowedRoles: ['Administrator'],   pathToMatch: ['^\/admin\/users.*','^\/admin\/user\/.*\/edit','^\/admin\/user\/add']},
    'full_access':{resourceLabel:'Full Mobile' },
    'processor_access':{resourceLabel:'Processor' },
    'finalizer_access':{resourceLabel:'Finalizer'},
    'put_away_access':{resourceLabel:'Put Away'},
    'pluck_access':{resourceLabel:'Pluck'},
    'pack_access':{resourceLabel:'Pack'},
    'wg_checkin_access':{resourceLabel:'WG Check-in'},
    'customer_service_access':{resourceLabel:'Customer Service'},
    'inventory_access':{resourceLabel:'Inventory'},
    'problem_solver_access':{   AllowedRoles: [ 'Administrator'], resourceLabel:'Problem Solver'},


}

module.exports = {
    applicationVersion: 18.73,
    getEnvironment: function (env = false) {
      let baseEnvironmentConfig = env ?  this.environments[env] : this.environments[process.env.NODE_ENV]
      let runtimeConfig = this.environments.runtime;

      // I know we're trying to migrate away from lodash,
      // but this is the fastest way to implement a selective recursive
      // merge of two objects
      let environmentConfig  = _.merge({}, baseEnvironmentConfig, runtimeConfig);
      return environmentConfig
    },
    getEnvironmentName: function () {
        return process.env.NODE_ENV
    },
    environments: {
        runtime: {
          serverBaseURL: process.env.SERVER_BASE_URL,
          directServerBaseURL: process.env.DIRECT_SERVER_BASE_URL,
          clientSideURL: process.env.CLIENT_SIDE_URL,
          shopify: {
            shopUrl: process.env.SHOPIFY_SHOP_URL,
          },
        },
        production: {
            serverBaseURL: 'https://api.goodbuygear.com',
            directServerBaseURL: 'https://reports.goodbuygear.com',
            clientSideURL: 'https://api.goodbuygear.com',
            IPABaseURL: 'https://ipa.goodbuygear.com',
            BlueBookBaseURL: 'https://bluebook.goodbuygear.com',
            ...configurations[process.env.NODE_ENV],
             plaid:{
                public_id: 'b03adf1972f05a7af6f67ba8cec094',
                mode:'production'
            },
        },
        development: {
            serverBaseURL: 'https://devapi.goodbuygear.com', //'http://localhost:3037',
            directServerBaseURL: 'https://devapi.goodbuygear.com',
            clientSideURL: 'https://devapi.goodbuygear.com',
            IPABaseURL: 'https://ipa.gbgstaging.com',
            BlueBookBaseURL: 'https://bluebook.gbgstaging.com',
            ...configurations[process.env.NODE_ENV],
            plaid:{
                public_id: 'b03adf1972f05a7af6f67ba8cec094',
                mode:'sandbox'
            },

        },
        test: {
            serverBaseURL: 'https://api.gbgstaging.com', //'http://localhost:3037',
            directServerBaseURL: 'https://api.gbgstaging.com',
            clientSideURL: 'https://api.gbgstaging.com',
            IPABaseURL: 'http://localhost:4000',
            BlueBookBaseURL: 'http://localhost:4000',
            ...configurations[process.env.NODE_ENV],
            plaid:{
                public_id: 'b03adf1972f05a7af6f67ba8cec094',
                mode:'sandbox'
            },

        },
        local: {
         serverBaseURL: 'http://localhost:3037',
            directServerBaseURL: 'http://localhost:3037',
            clientSideURL: 'http://localhost:8080',
            IPABaseURL: 'http://localhost:4000',
            BlueBookBaseURL: 'https://bluebook.gbgstaging.com',
            ...configurations[process.env.NODE_ENV],
            plaid:{
                public_id: 'b03adf1972f05a7af6f67ba8cec094',
                mode:'sandbox'
            },
        },
    },

    warehouseData: { /* MarketSettings*/
        Denver: {
            WorkWaveTerritoryID:'96e5ca82-2725-4a34-b6a9-6fb7d381090d',
            timeZoneName:'America/Denver',
            defaultCoordinates: {
                lat: 39.72907597237074,
                lng: -104.98187083782142
            },
            WarehouseAddressLink:'link_not_used',
            MarketName: 'Denver',
            address: 'address_not_used',
           // ShopifyWarehouseCode: "warehouse pickup [colorado]",
            warehouse: 'warehouse_1',
            warehousePickupReminderPhone:'17203587306',
            ZipCode: 80002,
            provinceCode:'CO',
        },
        NYC: {
            timeZoneName:'America/New_York',
            defaultCoordinates: {
                lat: 40.6813528,
                lng: -73.9854033
            },
            MarketName: 'NYC',
            ZipCode: 11217,
            provinceCode:'NY',
        },
        Dallas: {
            'FulfillmentCenter':'Philadelphia',
            WorkWaveTerritoryID:'ffd54373-5b73-4942-a001-7af3d23e9512',
            timeZoneName:'America/Chicago', /* US/Central'*/
            defaultCoordinates: {
                lat: 32.7766642,
                lng: -96.79698789999998
            },
            WarehouseAddressLink:'link_not_used',
            MarketName: 'Dallas',
            address: 'address_not_used',
        //   ShopifyWarehouseCode: "warehouse pickup [denver]",
          //  warehouse: 'warehouse_2',
            warehousePickupReminderPhone:'18445468518',
            ZipCode: 75001,
            provinceCode:'TX',

        },
        Houston: {
            'FulfillmentCenter':'Philadelphia',
            WorkWaveTerritoryID:'81b65abe-e998-4fc3-87c7-73c668768772',
            timeZoneName:'America/Chicago', /* US/Central'*/
            defaultCoordinates: {
                lat: 29.805220,
                lng: -95.523970
            },
            WarehouseAddressLink:'link_not_used',
            MarketName: 'Houston',
            address: 'address_not_used',
            warehousePickupReminderPhone:'18445468518',
            ZipCode: 75001,
            provinceCode:'TX',
        },
        DC: {
            WorkWaveTerritoryID:'54e3caa3-1043-498a-a61e-858ad69b66ac',
            timeZoneName:'America/New_York',
            defaultCoordinates: {
                lat: 38.881464,
                lng: -77.085477
            },
            WarehouseAddressLink:'link_not_used',
            MarketName: 'DC',
            address: 'address_not_used',
             warehousePickupReminderPhone:'18445468518',
            ZipCode: 20001,
            provinceCode:'VA',
            additionalProvinceCodes:['MD', 'DC']
        },
        Philadelphia: {
            SubMarkets: ['Dallas', 'Houston'],
            WorkWaveTerritoryID:'ebd97861-b0c0-4696-ab2c-eacc5cecbcdc',
            timeZoneName:'America/New_York',  /*https://gist.github.com/diogocapela/12c6617fc87607d11fd62d2a4f42b02a*/
            defaultCoordinates: {
                lat: 39.952583,
                lng: -75.165222
            },
            WarehouseAddressLink:'link_not_used',
            MarketName: 'Philadelphia',
            address: 'address_not_used',
            // warehouse: 'warehouse_4',
            warehousePickupReminderPhone:'18445468518',
            ZipCode: 19355,
            provinceCode:'PA',
            additionalProvinceCodes:[ 'NJ','DE'],
        },
        Ohio: {
            SubMarkets: ['Dallas', 'Houston'],
            WorkWaveTerritoryID:'',
            timeZoneName:'America/New_York',  /*https://gist.github.com/diogocapela/12c6617fc87607d11fd62d2a4f42b02a*/
            defaultCoordinates: {
                lat: 39.776913,
                lng: -83.02432
            },
            WarehouseAddressLink:'link_not_used',
            MarketName: 'Ohio',
            address: 'address_not_used',
            // warehouse: 'warehouse_4',
            warehousePickupReminderPhone:'18445468518',
            ZipCode: 43116,
            provinceCode:'OH',
            additionalProvinceCodes:[ 'NJ','DE'],
        }
    },
    get allSubMarkets(){
        return _.reduce(this.warehouseData,(subMarkets,item)=>{
            if (_.get(item,'SubMarkets',[]).length){
                return subMarkets.concat(_.get(item,'SubMarkets',[]))
            }else{
                return subMarkets
            }
        },[])
    },
    getMarket:function(params){
       return  _.find(this.warehouseData, {MarketName:params.MarketName})
    },
    get marketsList() {
        return _.map(this.warehouseData, function (item, key) {
            return {value: key, label: _.startCase(key)}
        })
    },
    boxSizeList:[
        {
            value:'Mailer',
            data: {Length:1, Width: 8, Height: 5},
            label: 'Express Pak mailer'
        },
        {
            value:'36x24x1',
            compareWithProductDimensions:true,
            data: {Length:25, Width: 25, Height: 23},
            label: 'Large Mailer'
        },
        {
            value:'24x19x1',
            compareWithProductDimensions:true,
            data: {Length:24, Width: 19, Height: 1},
            label: 'Medium Mailer'
        },
        {
            value:'20x14x1',
            compareWithProductDimensions:true,
            data: {Length:20, Width: 14, Height: 1},
            label: 'Medium Bubble Mailer'
        },
        {
            value:'8.75x2.625x5.25',
            data: {Length: 8.75, Width: 2.625, Height: 5.25},
            whole_number_values:{Length: 9, Width: 2, Height: 11},
           // label: '8.75 x 2.625 x 5.25',
            label: 'Express Small Box (or <420 in^3 GBG box)^'
        },
        {

            value:'8.75x4.375x5.25',
            data: {Length: 8.75, Width: 4.375, Height: 5.25},
            whole_number_values:{Length: 9, Width: 4, Height: 11},
            label: 'Express Medium Box (or <644 in^3 GBG Box)^'
        },
        {

            value:'8x8x5',
            data: {Length: 8, Width: 8, Height: 5},
            label: '8x8x5 (Express)'
        },
        {
            value: '12x9x6',
            data: {Length: 12, Width: 9, Height: 6},
            label: '12 x 9 x 6'
        },
        {
            value: '14x10x10',
            data: {Length: 14, Width: 10, Height: 10},
            label: '14 x 10 x 10'
        },
        {
            value: '15x15x10',
            data: {Length: 15, Width: 15, Height: 10},
            label: '15 x 15 x 10'
        },
        {
            value: '15x15x15',
            data: {Length: 15, Width: 15, Height: 15},
            label: '15 x 15 x 15'
        },
        {
            value: '20x16x6',
            data: {Length: 20, Width: 16, Height: 6},
            label: '20 x 16 x 6'
        },
        {
            value: '20x15x15',
            data: {Length: 20, Width: 15, Height: 15},
            label: '20 x 15 x 15'
        },
        {
            value: '20x16x8',
            data: {Length: 20, Width: 16, Height: 8},
            label: '20 x 16 x 8'
        },
        {
            value: '22x18x12',
            data: {Length: 22, Width: 18, Height: 12},
            label: '22  x 18 x 12'
        },
        {
            value: '24x16x6',
            data: {Length: 24, Width: 16, Height: 6},
            label: '24 x 16 x 6'
        },
        {
            value: '24x16x8',
            data: {Length: 24, Width: 16, Height: 8},
            label: '24 x 16 x 8'
        },
        {
            value: '25x25x20',
            data: {Length: 25, Width: 25, Height: 20},
            label: '25 x 25 x 20'
        },
        {
            value: '28x18x18',
            data: {Length: 28, Width: 18, Height: 18},
            label: '28 x 18 x 18'
        },
        {
            value: '28x24x6',
            data: {Length: 28, Width: 24, Height: 6},
            label: '28 x 24 x 6'
        },
        {
            value: '30x20x6',
            data: {Length: 30, Width:20, Height: 6},
            label: '30 x 20 x 6'
        },
        {
            value: '30x20x20',
            data: {Length: 30, Width:20, Height: 20},
            label: '30 x 20 x 20'
        },
        {
            value: '30x30x16',
            data: {Length: 30, Width:30, Height: 16},
            label: '30 x 30 x 16'
        },
        {
            value: '30x24x20',
            data: {Length: 30, Width:24, Height:20},
            label: '30 x 24 x 20'
        },
        {
            value: '32x18x8',
            data: {Length: 32, Width: 18, Height:8},
            label: '32 x 18 x 8'
        },

        {
            value: '36x16x5',
            data: {Length: 36, Width: 16, Height:5},
            label: '36 x 16 x 5'
        },
        {
            value: '36x20x15',
            data: {Length: 36, Width: 20, Height:15},
            label: '36 x 20 x 15'
        },
        {
            value: '36x24x20',
            data: {Length: 36, Width: 24, Height: 20},
            label: '36 x 24 x 20'
        },

        {
            value: '44x12x12',
            data: {Length: 44, Width: 12, Height: 12},
            label: '44 x 12 x 12'
        },
        {
            value: '38x28x18',
            data: {Length: 38, Width: 28, Height: 18},
            label: 'Or larger'
        }

    ],
    templateEngine: 'handlebars',
    amazon: {
        amazonAssociateID: 'goodbuygear01-20',
    },
    facebook: {
        requestDataUrl: 'https://graph.facebook.com', /* app in my facebook account https://developers.facebook.com/apps/1822807887994060/dashboard */
        appID: '1822807887994060'
    },
    checkAccessRights: function(params){
        var accessAllowed = false
        if (!params.userData){
            params.userData = this.props.userReducer.user
        }

        _.forEach(params.resources,item=>{
            if (_.size(_.intersection(_.get(rolesToResourcesAccessMap,[item,'AllowedRoles'],[]), params.userData.Roles))){
                accessAllowed =true
            }
            var allowedRoleData =item.split('_');
            if (allowedRoleData.length ==3){
                allowedRoleData = [allowedRoleData[0]+'_'+allowedRoleData[1], allowedRoleData[2]]
            }

            if (_.includes(_.get(params.userData, 'ResourceAccessRights',[]), item)) {

                accessAllowed =true
            }else if(allowedRoleData[1] == 'view'){ /* if _view role is allowed, _edit and _full roles are also allowed*/
                if (_.size(_.intersection([allowedRoleData[0]+'_edit',allowedRoleData[0]+'_full'],_.get(params.userData, 'ResourceAccessRights',[])))) {
                    accessAllowed =true
                }
            }  else if(allowedRoleData[1] == 'edit'){
                if (_.size(_.intersection([ allowedRoleData[0]+'_full'],_.get(params.userData, 'ResourceAccessRights',[])))) {
                    accessAllowed =true
                }
            }


        })

       return accessAllowed
    },
    perPageSelectOptions: [
        {value: 'all', label: 'All'},
        {value: '10', label: '10'},
        {value: '20', label: '20'},
        {value: '30', label: '30'},
        {value: '50', label: '50'},
        {value: '100', label: '100'},
        {value: '250', label: '250'},
    ],
      dispositionOptions: [
        {value: 'openbox_used', number:1, label: 'Open Box/Used'},
        {value: 'refurbish_parts',number:2, label: 'Refurbish/Parts'},
        {value: 'new_condition',number:4, label: 'New, Unopened'},
        {value: 'salvage',number:3, label: 'Damaged/Recalled'},
    ],
     orderShippingTypeOptions: [
        {value: 'Delivery', label: 'Local Delivery'},
        {value: 'Shipping', label: 'Shipping'},
        {value: 'Pickup', label: 'Warehouse Pickup'},
     ],
     table: {
        numberPerPage: 10
    },
    maps: {
        defaultCoordinates: {
            lat: 39.72907597237074,
            lng: -104.98187083782142
        },
        defaultPolygonCoordinates: [
            {lat: 39.759331595572036, lng: -104.97397899627686},
            {lat: 39.74197633162923, lng: -104.97389316558838},
            {lat: 39.74194333266686, lng: -104.96007442474365},
            {lat: 39.75936458620625, lng: -104.96007442474365}
        ],
        defaultZoom: 10,
        defaultBounds: {
            north: 40.80,
            south: 40.71,
            east: -106.07,
            west: -106.98
        }
    },
    product: {
        numberPerPage: 10,
        maxNumberPerPage: 250,
        shopifyProductBodyText2: function (data, productData) {

            var ModelVariationsToUseInDescriptions = _.filter(_.get(productData, 'ProductVariations', []), function (modelVariation) {
                return !modelVariation.UseInTitle
            })
            var ModelVariationsToUseInDescriptions = _.map(ModelVariationsToUseInDescriptions, function (modelVariation) {
                if (_.get(modelVariation, 'InputType') == 'text') {
                    var itemFound = _.find(tagValueToTextMap, function (item) {
                        return item.value == modelVariation.value
                    })
                    if (itemFound) {
                        modelVariation.value = itemFound.text
                    }
                }
                return modelVariation
            })
            return `<p>Condition: ${productData.Condition !== '' ? productData.Condition : ''}</p>
            ${ productData.Description !== '' ?
                `<p class="desc_text">"${productData.Description}"</p>`
                :
                ''}
             ${ ModelVariationsToUseInDescriptions.length > 0 ?
                `<ul class="desc_variations">
                ${ModelVariationsToUseInDescriptions.map(modelVariationToUseInDescription => `<li><i>${_.capitalize(modelVariationToUseInDescription.label) + ':  '}${modelVariationToUseInDescription.value}</i></li>`).join('')}
            </ul>`
                :
                ''}
            ${productData.OriginalUrl ? `<p class="desc_original_link">Would you rather pay full price for this item?  You can find a similar item${productData.OriginalUrl.includes('amazon.com') ? ' on Amazon' : '' } ${productData.OriginalDescription !== '' ? 'by clicking here' : 'by clicking' }
            <a target="_blank" ${productData.OriginalDescription !== '' ? 'title="' + productData.OriginalDescription + '"' : '' }  href="${productData.OriginalUrl}"><b>${productData.OriginalDescription !== '' ? productData.OriginalDescription : 'HERE' }</b></a></p>` : ''}`
        },
    },
    operatorsMap: {
        '<': function (a, b) {
            return a < b
        },
        '<=': function (a, b) {
            return a <= b
        },
        '>': function (a, b) {
            return a > b
        },
        '>=': function (a, b) {
            return a >= b
        },
        '==': function (a, b) {
            return a == b
        },
        'includes': function (a, b) {
            if (_.isArray(a)){
                return _.includes(a, b)
            } else{
                return false
            }
        },

        'oneOf': function (a, b) {
            console.log('a,b', a,b  );
            if (_.isArray(a) && _.isArray(b)){
                return _.size(_.intersection(a,b))>0
            } else  if (_.isArray(b)) {
                return _.includes(b, a)
            } else{
                return false
            }
        },

    },
    serviceStatusList:['Scheduled', 'Received', 'In Progress', 'Pre-Listings Done', 'Listings Done', 'Needs Pictures', 'Editing In Progress','Hold For Transport',
        'Out For Approval', 'Hold Donations For Pickup', 'Complete', 'Cancelled','Active'],
    apiErrorCodeMap: {
        10: 'UserNotFoundOnFacebookSignIn',
        11: 'UserAlreadyExistsOnSignUp',
        12: 'AccessTokenNotValid',
        13: 'FacebookEmailNotAvailableSignUp',
        14: 'ProductImageUploadError',
        15: 'errorPasswordNotCorrect',
        16: 'UserNotFoundOnPasswordSignIn',
        17: 'ResetPasswordCodeNotCorrect',
        18: 'NewMajorAppVersionIsAvailable',
        19: 'NewMinorAppVersionIsAvailable',
        20: 'RecordNotFound',
        21: 'ClientApplicationVersionMustBeUpdated',
     },
    // iframeDataMap:{
    //     'dashboard/subscriptions':{
    //         elementID:'subscriptionsList',
    //     },
    //     'products/subscriptions':{
    //         elementID:'productsList',
    //     },
    // },
    bootstrapTableOptions: {
        page: 1,  // which page you want to show as default
        sizePerPage: 100,  // which size per page you want to locate as default
        paginationSize: 5,  // the pagination bar size.
        prePage: 'Prev', // Previous page button text
        nextPage: 'Next', // Next page button text
        firstPage: 'First', // First page button text
        lastPage: 'Last' // Last page button text
    },

    services: {
        timeWindowOptions: [
            {'label': '8am - 5pm', 'value': '8_17'},
            {'label': '8am - 10am', 'value': '8_10'},
            {'label': '8am - 5pm', 'value': '8_17'},
            {'label': '9am - 11am', 'value': '9_11'},
            {'label': '9am - 12pm', 'value': '9_12'},
            {'label': '9am - 1pm', 'value': '9_13'},
            {'label': '9am - 4pm', 'value': '9_16'},
            {'label': '9:30am - 11:30am', 'value': '9.30_11.30'},
            {'label': '10am - 12pm', 'value': '10_12'},
            {'label': '11am - 1pm', 'value': '11_13'},
            {'label': '12pm - 4pm', 'value': '12_16'},
            {'label': '12pm - 2pm', 'value': '12_14'},
            {'label': '1pm - 3pm', 'value': '13_15'},
            {'label': '2pm - 4pm', 'value': '14_16'},
            {'label': '3pm - 5pm', 'value': '15_17'},
            {'label': '4pm - 6pm', 'value': '16_18'},
            {'label': '6pm - 8pm', 'value': '18_20'}
        ],
        daysOfWeekMap: [
            {'label': 'Monday', 'value': 2},
            {'label': 'Tuesday', 'value': 3},
            {'label': 'Wednesday', 'value': 4},
            {'label': 'Thursday', 'value': 5},
            {'label': 'Friday', 'value': 6},
            {'label': 'Saturday', 'value': 7},
            {'label': 'Sunday', 'value': 1},


        ],
        serviceTypesMap:[
            {value:'Pickup', label:'Pick-up'},
            {value:'Dropoff', label:'Drop-off'},
            {value:'Mail In', label:'Mail in'}
        ],
        pickup: {

            sizeOptions: [
                {
                    'label': 'Send the Prius! (I have a few great items)',
                    disabled: false,
                    size: 1,
                    internalLabel: 'Small',
                    units: 400,
                    'value': 1
                },
                {
                    'label': "Send the SUV! (I'm not messing around)",
                    internalLabel: 'Medium',
                    disabled: false,
                    size: 2,
                    units: 600,
                    'value': 2
                },
                {
                    'label': "Send the Cargo Van! (I'm drowning in clutter!!)",
                    disabled: false,
                    internalLabel: 'Large',
                    size: 4,
                    units: 1200,
                    'value': 4
                },
                {
                    'label': 'Extra large (Fits in back of suv)',
                    internalLabel: 'Extra large',
                    disabled: false,
                    size: 5,
                    units: 1500,
                    'value': 5
                },
                {
                    'label': 'Huge (Fits in pickup truck)',
                    disabled: false,
                    internalLabel: 'Huge',
                    size: 6,
                    units: 1800,
                    'value': 6
                },
            ],

        },
        dropoff: {

            sizeOptions: [
                {'label': 'Small (Fits in the shoebox)', internalLabel: 'Small', 'value': 1},
                {'label': 'Medium (Fits in the front seat)', internalLabel: 'Medium', 'value': 2},
                {'label': 'Large (Fits in the back seat)', internalLabel: 'Large', 'value': 4},
                {'label': 'Extra large (Fits in back of suv)', internalLabel: 'Extra large', 'value': 5},
                {'label': 'Huge (Fits in pickup truck)', internalLabel: 'Huge', 'value': 6},
            ],
            //   DaysOfWeek: [1, 2, 3, 4, 5, 6, 7],
            //   maximumSizeNumberForTimeSlot:8,
        },

        "mail in": {
            sizeOptions: [
                {'label': 'Small (Fits in the shoebox)', internalLabel: 'Small', 'value': 1},
                {'label': 'Medium (Fits in the front seat)', internalLabel: 'Medium', 'value': 2},
                {'label': 'Large (Fits in the back seat)', internalLabel: 'Large', 'value': 4},
                {'label': 'Extra large (Fits in back of suv)', internalLabel: 'Extra large', 'value': 5},
                {'label': 'Huge (Fits in pickup truck)', internalLabel: 'Huge', 'value': 6},
            ],
        }
    },
    sellerProductTags: [
        {value: 'PetFree', label: 'Pet-free'},
        {value: 'SmokeFree', label: 'Smoke-free'}],
    sellerTypes: [
        {value: 'INTERNAL', label: 'INTERNAL'},
        {value: 'MCN', label: 'MCN'},
        {value: 'LVI', label: 'LVI'},
        {value: 'HVI', label: 'HVI'},
        {value: 'CANCELED', label: 'CANCELED'},
        {value: 'OutofService', label: 'Out of Service'},
    ],
    sellerTypes: [
        {value: 'INTERNAL', label: 'INTERNAL'},
        {value: 'MCN', label: 'MCN'},
        {value: 'LVI', label: 'LVI'},
        {value: 'HVI', label: 'HVI'},
        {value: 'CANCELED', label: 'CANCELED'},
        {value: 'OutofService', label: 'Out of Service'},
    ],

    allPaymentMethodOptions:  [{
            group: 'StoreCredit',
            label: 'Store Credit (Good Buy Bucks)',
            value: 'GoodBuyBucks'
        },
            {
                group: 'Cash',
                label: 'Cash (PayPal)',
                value: 'Paypal'
            },
            {
                group: 'Cash',
                label: 'Cash (Check)',
                value: 'Check'
            },
            {
                group: 'Donation',
                label: 'Donate (WeeCycle)',
                value: 'DonateWeeCycle',
                'email': 'WeeCycle'
            },
            {
                group: 'Donation',
                label: 'Donate (Hope House)',
                value: 'DonateHopeHouse',
                'email': 'HopeHouse'
            },
            {
                group: 'Donation',
                label: 'Donate (Children\'s Hospital)',
                value: 'DonateChildrenHospital',
                'email': 'ChildrenHospital'
            },

    ],

    feesData: {
        'BatteryFee': {'Description': 'Replacement Batteries', amount: 5},
        'ReassemblyFee': {'Description': 'Re-assembly Fee', amount: 5},
        'LaundryFee': {'Description': 'Laundry Fee', amount: 5},
        'PrintCarSeatManual': {'Description': 'Printing Car Seat Manual Fee', amount: 5},
        'CleaningFee': {'Description': 'Cleaning Fee'},
        'ReplacementPart': {'Description': 'Replacement Part'},
    },
    buyerResponseToTextMap: {
        '1': {userMessage: 'I\'ll be there', responseMessage: "Got it! See you soon"},
        '2': {
            userMessage: 'I\'d like to upgrade delivery',
            responseMessage: "Great, here is a link to upgrade:\r\n  https://bit.ly/2OIfLuC"
        },
        '3': {userMessage: 'Please give me an extension, I will be there!', responseMessage: "Got it! See you soon"},
        '4': {userMessage: 'Please cancel', responseMessage: "Ok, no problem. We'll follow-up shortly"},
    },
    servicesHoursMap: {8: 8, 9: 9, 10: 10, 11: 11, 12: 12, 13: 1, 14: 2, 15: 3, 16: 4, 17: 5, 18: 6},
    donationOrganizations: [
        {
            label: 'Children’s Hospital',
            PageID: 'donate-to-childrens-hospital-of-colorado',
            value: 'Children_Hospital_CO'
        },
        {label: 'Hope House', PageID: 'donate-to-hope-house', value: 'Hope_House'},
    ],

    inventoryOwnershipMap: [
        {value: 'PartnerPurchased', label: 'GBG'},
        {value: 'PartnerConsigned', label: 'Partner'},
        {value: 'SellerConsigned', label: 'Seller'}
    ],
    productStatusMap: [
        {value: 'Active', label: 'Active'},
        {value: 'Inactive', label: 'Inactive'}
    ],

    productConditions: [
        'Loved',
        'Gently Used',
        'Open Box',
        'Barely Used',
        'Brand New'
    ],
    transactionTypesMap: [
        {value: 'Sale', label: 'Sale'},
        {value: 'PickupFee', label: 'Pickup Fee'},

        {value: 'Fee', label: 'Fee'},
        {value: 'Credit', label: 'Credit'},
        {value: 'PayBonus', label: 'Pay Bonus'},
        {value: 'Payout', label: 'Payout'},

    ],
    transactionStatusMap: [
        {value: 'Pending', label: 'Pending'},
        {value: 'PendingPayout', label: 'Pending Payout'},
        {value: 'Paid', label: 'Paid'},
        {value: 'Sold', label: 'Sold'},
        {value: 'PendingReturn', label: 'Pending Return'},
        {value: 'Forfeited', label: 'Forfeited'},
        {value: 'Returned', label: 'Returned'},
        {value: 'Restocked', label: 'Restocked'}
    ],
    conditionsData: [
        {'label': 'Brand New', 'value': 'Brand New','tag': 'Brand New',number:0,percent:0.80, percentBundles:0.7,
            scaleData:{color: '#1D553F', promptWrapper: { top: 48 },  seller: [100, 100]}   },
        {'label': 'Open Box', 'value': 'Open Box',tag: 'Open Box',number:1,  disposition: 'new_condition', percent:0.80, percentHotBuy:0.85 ,percentBundles:0.60,
            scaleData:{color: '#4F9C7E', promptWrapper: { top: 119 }, partner: [81, 100]}},
        {'label': 'Open Box Missing Accessory', 'value': 'OpenBoxMinorIssues',tag: 'Open Box',number:2,disposition: 'openbox_used' ,percent:.50, percentHotBuy:.55 ,percentBundles:.40  },
        {'label': 'Barely Used', 'value': 'Barely Used',tag: 'Barely Used', number:4, disposition: 'openbox_used',percent:0.60, percentHotBuy:0.65 ,percentBundles:0.50,
            scaleData:{color: '#CEE244', promptWrapper: { top: 192 },   partner: [61, 80], seller: [61, 99]}},
        {'label': 'Gently Used', 'value': 'Gently Used',tag: 'Gently Used',number:5, disposition: 'openbox_used' ,percent:0.50, percentHotBuy:0.55 ,percentBundles:0.40,
            scaleData: {color: '#FAF149', promptWrapper: { top: 265 },partner: [41, 60], seller: [41, 60]}},
        {'label': 'Gently Used With Issues', 'value': 'GentlyUsedMinorIssues',tag:'Gently Used',number:6,disposition: 'openbox_used',percent:0.45, percentHotBuy:0.50 ,percentBundles:0.35 ,
            scaleData:{color: '#EBBF27', promptWrapper: { top: 336 }, partner: [21, 40], seller: [21, 40]}},

        {'label': 'Loved', 'value': 'Loved',  'tag': 'Loved', number:7,disposition: 'openbox_used' ,percent:0.35 , percentHotBuy:0.40 ,percentBundles:0.25,
            scaleData:  {color: '#D14228', promptWrapper: { top: 408 },   partner: [1, 20], seller: [1, 20]}},
        {'label': 'Donate',  number: 'n/a', scaleData: {color: '#6A281C', promptWrapper: { top: 475 }, label: 'Donate', partner: [0, 0], seller: [0, 0]} },
        {'label': 'Dispose-not an accepted item', 'value': 'Dispose',  'tag': 'Dispose', number:8, disposition: 'salvage'  },
    ],
    deterministicQualityCheckTypes: {ShowFirst: 'Show First', Base:'Base'},
    seasonToMonthMap: {
        'winter': {
            months: [12, 1, 2]
        },
        'spring': {
            months: [3, 4, 5]
        },
        'summer': {
            months: [6, 7, 8]
        },
        'autumn': {
            months: [9, 10, 11]
        }
    },
    timeTrackingActivityData: [
        {name: 'PostingHome', comment: 'Finalizing', allowedAccessRights:[  'finalizer_access'] },
        {name: 'PostingWarehouse', comment: 'Posting at warehouse', allowedAccessRights:['processor_access','customer_service_access'] },
        {name: 'PuttingAway', comment: 'Putting away',allowedAccessRights:[ 'put_away_access','customer_service_access'] },
        {name: 'Fulfillment', comment: 'Fulfillment', allowedAccessRights:[ 'pluck_access','pack_access','customer_service_access'] },
        {name: 'CustomerService', comment: 'Customer service',allowedAccessRights:[ 'customer_service_access'] },
        //{name: 'Photos', comment: 'Photos',allowedAccessRights:['] },
        {name: 'Driving', comment: 'Driving',allowedAccessRights:['pluck_access','pack_access', ] },
        {name: 'Meeting', comment: 'Meeting',allowedAccessRights:['processor_access', 'finalizer_access',
            'put_away_access','pluck_access','pack_access','wg_checkin_access','customer_service_access'] },
        {name: 'Other', comment: 'Other',allowedAccessRights:['processor_access','finalizer_access','put_away_access'
            ,'pluck_access','pack_access','wg_checkin_access','customer_service_access'] }
    ],

    warehousePickupStatusMap: [
        {value: 'Pending', label: 'Pending'},
        {value: 'Fulfilled', label: 'Fulfilled'},
        {value: 'Returned', label: 'Returned'}
    ],
    subscriptionTypes: {
     //   'service_approval_with_donations': {label: "Service Approval With Donations",  KlaviyoTemplateID:'JQvwbW', emailTemplate: 'service_approval_with_donations'},
       // 'service_approval_without_donations': {label: "Service Approval Without Donations",  KlaviyoTemplateID:'LeJBTJ', emailTemplate: 'service_approval_without_donations'},
       //   'warehouse_pickup_order_reminder_dallas': {label: "Warehouse Pickup Order Reminder Dallas",  KlaviyoTemplateID:'UsFZ7N', emailTemplate: 'warehouse_pickup_order_reminder_dallas'},
     //   'warehouse_pickup_order_reminder_denver': {label: "Warehouse Pickup Order Reminder Denver",  KlaviyoTemplateID:'SuZAUx', emailTemplate: 'warehouse_pickup_order_reminder_denver'},
       //   'dropoff_confirmation_dallas': {label: "Drop-off Confirmation Dallas",  KlaviyoTemplateID:'QNu3bM', emailTemplate: 'service_confirmation'},
    //      'dropoff_confirmation_denver': {label: "Drop-off Confirmation Dallas",  KlaviyoTemplateID:'WaEVN4', emailTemplate: 'service_confirmation'},
     //    'pickup_confirmation': {label: "Pickup Confirmation",  KlaviyoTemplateID:'SNTFwS', emailTemplate: 'service_confirmation'},

        'SoldOut': {label: "Product sold out",  emailTemplate: 'product_soldout'},

        'InStock': {label: "Sold out",  KlaviyoTemplateID:'JRkdzJ', emailTemplate: 'product_instock'},
        "PriceDrop": {label: "Price Drop", KlaviyoTemplateID:'HypXAS', emailTemplate: 'product_price_drop'},
        "Favorites": {label: "Favorites", emailTemplate: ''},
        "ServiceAvailability": {label: "Service available", emailTemplate: ''}
    },
    inventoryProjectTypes:[   {value: 'SpotCheck', label: 'Spot Check'},
        {value: 'Monthly', label: 'Monthly'},
        {value: 'BiAnnual', label: 'Bi-Annual'}],
    GBGProductsVariationTypes: [
        {value: 'select', label: 'Select box', Description: '', options: []},
        {value: 'input', label: 'Text Input', Description: '', options: []},
        {value: 'text', label: 'Fixed tag', Description: '', options: []},
    ],
    qualityChecksInstructionsMap : {
        "donate- recalled item": 'recalled',
        'bring to troubleshooting room': 'troubleshooting room',
        'donate': 'donate'
    },

    rolesToResourcesAccessMap:rolesToResourcesAccessMap,
 //   userAccessRights: userAccessRights,
    payoutMethodsMap: {
        'Paypal': "PayPal",
        "Check": "Check",
        "Venmo": "Venmo",
        "Bill.com": "Bill.com",
        "TriNet": "TriNet",
        "GoodBuyBucks": "Good Buy Bucks",
        "buybuyBABY": "Buy Buy Baby",
        "Donate": "Donate",
        "DirectDeposit":'Direct Deposit'
    },
     userRoles:['User', 'Wingmom','AMT Team', 'Ops Manager', 'Product Manager','Financial Analyst', 'Administrator' ] ,
    tagValueToTextMap: tagValueToTextMap,
    ageGroups: [
        {value: '0-3 months', label: '0-3 months', allowed: true},
        {value: '3-12 months', label: '3-12 months', allowed: true},
        {value: '10+ years', label: '10+ years', allowed: true},
        {value: 'Toddler', label: 'Toddler', allowed: true},
        {value: 'Infant', label: 'Infant', allowed: false},
        {value: 'Preschool', label: 'Preschool', allowed: true},
        {value: 'Gradeschool', label: 'Gradeschool', allowed: true},
        {value: 'Grown-up', label: 'Grown-up', allowed: true},
    ],
    apiMessages: {
        errorIncorrectChildID: 'Data not found for the child',
        errorShopifyAccessDenied: 'Invalid signature. Access denied',
        errorSomethingWrong: 'Something went wrong',
        errorZipNotFoundForCoordinates: 'Zip code not found for specified coordinates',
        errorMetroAreaNotFoundForZipCode: 'Zip code does not match any of the allowed Metro Areas',
        errorAddressNotFoundForCoordinates: 'Address data not found for specified coordinates',
        errorLocationNotFoundForAddress: 'Geodata not found for specified address',
        errorAddShopify: 'Something went wrong when adding #1# in Shopify',
        errorFetchShopify: 'Something went wrong when getting  #1# from Shopify',
        errorUpdateShopify: 'Something went wrong when updating #1# in Shopify',
        errorCheckoutShopify: 'Something went wrong when performing checkout in Shopify',
        errorProductHasManyImages: 'This product has many images. Please, contact an administrator to delete the product',
        errorDeleteShopify: 'Something went wrong when deleting #1# in Shopify.' +
        ' Please, delete the record manually on Shopify website',
        errorUniqueField:"#1# #2# already exists #3#",
        errorAssignProductToCollectionShopify: 'Something went wrong when adding product to collection in Shopify',
        errorDeleteProductToCollectionShopify: 'Something went wrong when deleting product from collection in Shopify',
        errorProductAlreadyExistsInCollectionShopify: 'Product already exists in this collection',
        errorAddImageS3: 'Something went wrong when saving image',
        errorDeleteImageS3: 'Something went wrong when deleting image',
        errorFieldMissing: 'Action can not be performed. Field #1# is not available',
        errorParameterNotSpecified: '#1# not specified',
        errorDeletingRecord: "Sorry, can not delete #1#. #2#",
        errorRecordNotFound: 'Sorry, #1# not found',
        errorWorkingTimeLogNotInPendingPayout: 'Transaction amount can not be updated as #1# of working time records are not in Pending Payout status',
        errorEmailNotValid: 'Please, specify valid email address', /* returned if email is not valid on signup */
        errorEmailNotValidCustom: 'Please, specify valid email address #1#',
        warningSubscriptionAlreadyDeleted: 'You have already unsubscribed from this notification',
        warningSubscriptionAlreadyDeletedAdmin: 'Subscription already set as Deleted',
        warningAlreadySubscribed: 'You have already subscribed to this notification',
        warningAlreadyAddedToFavorites: 'Product is already added to Favorites',
        warningAlreadyRemovedFromFavorites: 'Product is already removed from Favorites',
        errorNotValid: '#1# is not valid',
        errorUserAlreadyExistEmailFacebook: 'You have already signed up with this email using current Facebook account. Please use Log In form',
        errorUserAlreadyExistEmailPassword: 'You have already signed up with this email. Please specify your email and password in Log In form',
        errorUserAlreadyExistEmail: 'You have already signed up with this email. Please use Log In form',
        errorFacebookUserNotFoundSignin: 'Sorry we can\'t find your user account. We apologize for the inconvenience.',
        errorShopifyUserExistOnSignin: 'Sorry we can\'t find your user account. ' +
        'If you have logged in to our website in the past you will need a new login for this app. We apologize for the inconvenience.',
        //errorImageUploadImageS3: 'Error occurred while saving image. Please, upload this image again',
        //errorFileUpload: 'Uploaded file is not valid. Only images of less than 8MB can be uploaded',
        errorImageNumberDoNotMatch: 'Number of passed images do not correspond to the number of stored product images',
        errorPickupAddressValidation: 'Pickup address should include Street, City, State and Zip data',
        errorImageUpload: 'Error occurred when saving image. Image data is not valid',
        errorCartProductNotFound: 'Product #1# is currently not available for purchase',
        errorOriginalUrlIsNotValid: 'Product url #1# can not be processed',
        errorPasswordNotCorrect: 'Password is not correct',
        errorUserWithEmailNotFound: 'User associated with this email not found',
        emailAssociatedWithFacebook: 'Email associated with existing Facebook account. Please use Facebook to login',
        passwordNotSetForUserTryingToLogin: 'Password is not set for your user record. Please, set it using Forgot password link',
        errorResetPasswordCodeNotCorrect: 'Reset password code is not correct',
        ResetPasswordTokenExpiredError: 'Reset password number code has expired. It is valid for 24 hours',
        // UnsubscribeNotificationTokenExpiredError: 'Unsubscribe link has expired. It is valid for 30 days',
        TokenExpiredError: "Please, sign in again. This token has expired",
        TokenExpiredErrorShopify: "Please, refresh the page. This token has expired",
        errorRecordAlreadyCreated: '#1# record has been already created',
        errorCartProductNotSufficientQuantity: 'Only #2# items of #1# is currently available for purchase. Please, change quantity of this product',
        errorFacebookEmailNotAvailable: 'Could not get email from Facebook account. Please, specify your email address',
        errorPermissions: 'Resource access denied',
        errorForgotPasswordUserNotFound: 'Sorry, we cannot reset your password as your account is linked with Facebook',
        UserNotFoundOnPasswordSignIn: 'Sorry, we cannot find the account associated with this email',
        newAppVersionIsAvailable: 'We have a new version of our app available for download from the App Store. We promise it will be worth the work!',
        errorPaymentDataNotSpecified: '#1# not specified for Seller payment method',
        pickupTimeSlotIsNotAvailable: 'Sorry, selected date and time for #1# is already reserved',
        errorRecordExpired: 'Sorry, #1# has expired',
        noRecordsFoundForSellerPayoutRequest: 'No pending transactions found',
        wrongPhoneNumber: 'Please enter a valid phone number to use this delivery method'
    },
    clientMessages: {
        /* messages used in client webapp */
        recordDeleted: '#1# has been deleted',
        emailWithActivationCodeSent: 'Email with activation code has been sent',
        passwordHasBeenReset: 'Password has been reset',
        recordUpdated: '#1# updated',
        recordSetAsDeleted: '#1# set as Deleted',
        recordAdded: '#1# has been added',
        pickupScheduled: 'Pickup has been scheduled',
        recordsUpdated: '#1# have been updated',
        errorSomethingWrong: 'Something went wrong',
        productImageUpdated: 'Image has been updated',
        vendorProductImageUpdated: 'Shopify image has been updated',
        vendorProductImageDeleted: 'Shopify image has been deleted. Please, specify another image to use for Shopify product',
        productImageOrderUpdated: 'Order of images has been updated',
        errorSellerPickupAddress: 'Please, specify all fields for pickup address',
        errorFieldRequired: '#1# is a required field',
        errorAtLeastOneRequired: "Please, add at least one #1#",
        errorAddressOutsideServiceAreas: "Sorry, location is outside of available service areas",
        errorAddressOutsideSelectedLocation:  "Sorry, address is outside of the selected location",
        errorAddressNotIncludeFullData: "Please modify the address to include address, city, state and zip code",
        errorFieldNotSpecified: "Please, specify #1#",
        errorFieldNotSelected: "Please, select #1#",
        errorDateIsNotValid: "Specified date is not valid",
        errorDateIsNotAvailable: "The selected date is not available. Please, choose other date.",
        errorOrderAddressIsOutOfAvailableServiceAreas: "Please, use address within available service areas",
        errorNotUnique: "#1# not unique",
        errorTokenExists: 'Facebook token not available',
        errorConnection: 'Internet connection or server is not available',
        noRecordsFoundForCriteria: 'No #1#  found',
        errorFileUpload: 'Uploaded file is not valid. Only images of less than 8MB can be uploaded',
        warningAdminNoProductsSelected: 'Please, select at least one product',
        errorAccessResource: 'Sorry, access is not allowed',
        sellerPayoutConfirmationNotSent: 'Payout confirmation has not been sent to the seller',
         transactionsUpdateEmailsSentToSellers: 'Transactions update #1# sent to #2##3#',
        categoriesDescriptionsImported: 'All descriptions for categories has been imported',
        promoCodeHasBeenApplied: 'Promo code applied',
    },
    Constants:{
        IS_PRODUCTION : process.env.NODE_ENV == 'production',
        IS_DEVELOPMENT : process.env.NODE_ENV == 'development',
        IS_LOCAL : process.env.NODE_ENV == 'local',
        IS_TEST : process.env.NODE_ENV == 'test',
        IS_REMOTE_SERVER : process.env.NODE_ENV == 'production' || process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'staging',
    },
    Colors:{
        pink:'#ef5085',
        purple:'#6F7DB8',
        navyblue:'#212645',
        gray: '#BDBBBB'
    }
};
